import * as Sentry from "@sentry/react";
import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { reloadOnceForStaleChunk, clearStaleChunkReloadGuard } from "@shared/utils/chunkErrorRecovery";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// إصلاح فشل تحميل chunk قديم بعد نشر جديد للموقع (vite:preloadError)
window.addEventListener("vite:preloadError", () => {
  reloadOnceForStaleChunk();
});

// وصلنا هنا يعني التحميل الحالي نجح — نفرّغ العلم لإعادة تفعيل الحماية لأي فشل مستقبلي
clearStaleChunkReloadGuard();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
